import { render, staticRenderFns } from "./TitleHorizontalList.vue?vue&type=template&id=127ee6ca&scoped=true&"
import script from "./TitleHorizontalList.vue?vue&type=script&lang=js&"
export * from "./TitleHorizontalList.vue?vue&type=script&lang=js&"
import style0 from "./TitleHorizontalList.vue?vue&type=style&index=0&id=127ee6ca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127ee6ca",
  null
  
)

export default component.exports